export const enum AppRoutes {
    LandingPage = '/login',
    SettingsPage = '/settings',
    HomePage = '/',
    LogoutPage = '/logout',
    CookiesPage = '/cookies',
    TandC = '/tandc',
    PrivacyPage = '/privacy',
    ContactPage = '/contact',
    AccessibilityStatement = '/accessibility',
    Unauthorized = '/403',
    Management = '/admin/management',
    Tenant = '/admin/management/tenant',
    ApplicationPolicies = '/admin/applicationPolicies',
    BusinessMetrics = '/admin/businessMetrics',
    CreateProcess = '/processes/CreateProcess',
    Process = '/process/:processId',
    ProcessUploadedDocuments = '/process/:processId/uploaded',
    ProcessDocumentsProcessing = '/process/:processId/document',
    Folder = '/folder/:folderId',
    FolderRoot = '/folder',
    UploadDocumentEdit = '/process/:processId/uploaded/:documentId/:status',
    ProcessDocumentEdit = '/process/:processId/document/:documentId',
    OnlineFormEdit = '/process/:processId/online-form/:documentId',
    ExtractionSettings = '/admin/extraction-settings',
    ExtractionDocTypeSettings = '/admin/extraction-settings/document-type-settings',
    ExtractionValidationSettings = '/admin/extraction-settings/validation-settings',
    FillPDFSettings = '/admin/fill-pdf-settings',
    FillPDFDocTypeSettings = '/admin/fill-pdf-settings/document-type-settings',
    FillPDFValidationSettings = '/admin/fill-pdf-settings/validation-settings',
    FillPDFEdit = '/process/:processId/fill-pdf/:documentId',
    FillOnlineSettings = '/admin/fill-online-settings',
    FillOnlineDocTypeSettings = '/admin/fill-online-settings/document-type-settings',
    FillOnlineValidationSettings = '/admin/fill-online-settings/validation-settings',
}

export const LoginRedirectStorageKey = 'returnRoute';
